export default __webpack_public_path__ + "f02746cf78f49a372840eaa9768e4d08.png";